import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { useStyles } from './useStyles';
import LoadingIconClear from '../../atoms/LoadingIconClear';

type Props = {
  open: boolean;
};

const Loading: React.FC<Props> = ({ open }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open} invisible={true}>
      <div className={classes.loadingIconClearWrapper}>
        <LoadingIconClear />
      </div>
    </Backdrop>
  );
};

export default Loading;
